import {useEffect} from 'react'
import {Navigate, Outlet, Route, Routes, useParams} from 'react-router-dom'
import {PageHeader} from '../layout/PageHeader'

const AccountPage = () => {
  const {id} = useParams()

  useEffect(() => {
    if (!id) {
      return
    }

    const timeoutId = window.setTimeout(() => {
      window.notifyInitializePortfolioAccountPage(id)
    }, 2000)

    return () => window.clearTimeout(timeoutId)
  }, [id])

  return (
    <>
      <PageHeader
        eyebrow='Портфель'
        title='Выбранный счёт'
        description='Позиции, остатки и доходность по брокерскому счёту.'
      />
      <portfolio-account-page id='portfolio-account-page' />
    </>
  )
}

const PortfolioAccountsPage = () => (
  <Routes>
    <Route element={<Outlet />}>
      <Route
        path='overview'
        element={
          <>
            <PageHeader
              eyebrow='Капитал'
              title='Портфель'
              description='Сводная структура активов по всем подключённым счетам.'
            />
            <portfolio-overview-page />
          </>
        }
      />
      <Route path='account/:id' element={<AccountPage />} />
      <Route index element={<Navigate to='/portfolio/overview' />} />
    </Route>
  </Routes>
)

export default PortfolioAccountsPage
